import {
  MenuItem,
  MenuList,
  Typography,
  Box,
  Modal,
  Dialog,
  DialogTitle,
  List,
  ListItemButton,
  ListItem,
  ListItemText
} from '@mui/material';
import { updateFlightTestPlan } from 'actions/flightTestPlanActions';
import { useAppDispatch } from 'hooks/redux';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

interface ContextProps {
  handleExit: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  testPlan: any;
  open: boolean;
}

export const FlightTestContext = React.memo((props: ContextProps) => {
  const dispatch = useDispatch();

  const updateStatus = () => {
    dispatch(updateFlightTestPlan(props.testPlan, 'CANCELLED'));
  };
  return (
    <>
      <Dialog fullWidth open={props.open} onClose={props.handleExit}>
        <DialogTitle>Update Status</DialogTitle>
        <List sx={{ pt: 0, left: 8 }}>
          <ListItem disableGutters>
            <ListItemButton onClick={() => updateStatus()}>
              <ListItemText primary={'Cancel Test Plan'} />
            </ListItemButton>
          </ListItem>
        </List>
      </Dialog>
    </>
  );
});
